import type { StateCreator } from "zustand";

import type { CheckoutDiscount } from "@/features/payments/api";

export interface CheckoutSlice {
  checkoutDiscount?: CheckoutDiscount;
  setCheckoutDiscount: (checkoutDiscount?: CheckoutDiscount) => void;
}

export const createCheckoutSlice: StateCreator<
  CheckoutSlice,
  [],
  [],
  CheckoutSlice
> = (set) => ({
  setCheckoutDiscount: (checkoutDiscount) => set({ checkoutDiscount }),
});
